export const CROWN_BUTTON_TITLE_TOOLTIP = {
  'Base Color': 'stainingCorrection.panel.crownButtonTooltip.baseColor',
  'Fine Details': 'stainingCorrection.panel.crownButtonTooltip.fineDetails',
  'Translucent Details':
    'stainingCorrection.panel.crownButtonTooltip.translucentDetails',
}

export const CROWN_BUTTON_WITH_COLOR = {
  'Base Color': {
    Cervical: 'linear-gradient(90deg, #FFBF95 0%, #FF6F6D 100%)',
    Middle: 'linear-gradient(90deg, #F8B1AB 0%, #8EE6BD 100%)',
    Incisal: 'linear-gradient(90deg, #C3D4FF 0%, #F4BCCD 100%)',
  },
  'Fine Details': {
    'Light Absorption': 'linear-gradient(90deg, #AFCACB 0%, #B47AA2 100%)',
    'Light Reflection': ' linear-gradient(90deg, #EDF8A7 0%, #38CFB1 100%)',
    'Mamelon/Halo': 'linear-gradient(90deg, #FAFD88 0%, #FC9261 100%)',
  },
  'Translucent Details': {
    'Amber Opal': 'linear-gradient(90deg, #FFB975 0%, #BCF7E2 100%)',
    'Enamel Effect': 'linear-gradient(90deg, #CE81FF 0%, #3FD8FF 100%)',
    'Blue Opal': 'linear-gradient(90deg, #49C4FF 0%, #BDF8E2 100%)',
  },
}

export const REGIONS_BACKGROUND: Record<string, string> = {
  region1: '#68CEA1',
  region2: '#FFB975',
  region3: '#FF9DBF',
}
export const STUMP_SHADE_BUTTON_WITH_COLOR = {
  'Base Color': {
    Cervical: 'linear-gradient(90deg, #FFBF95 0%, #FF6F6D 100%)',
    Middle: 'linear-gradient(90deg, #F8B1AB 0%, #8EE6BD 100%)',
    Incisal: 'linear-gradient(90deg, #C3D4FF 0%, #F4BCCD 100%)',
  },
}

export const WASH_BAKE_BACKGROUNDS: Record<string, string> = {
  CERVICAL: '#FF5C88',
  MIDDLE: '#68CEA1',
  INCISAL: '#2B66F6',
}
